import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BaseButtonComponent } from './base-button.component';

@Component({
  standalone: true,
  imports: [CommonModule, BaseButtonComponent],
  selector: 'app-tip-button',
  template: `
    <app-base-button
      [baseClass]="'w-16 h-16 rounded-2xl bg-theme-surface2 px-6 py-2 text-theme-primary text-lg border-2 ' +
                  (selected ? 'border-theme-primary' : 'border-transparent')"
      [disabled]="disabled"
      (onClick)="onClick.emit($event)"
    >
      <div class="flex justify-center w-full items-center">
        <span class="text-center text-lg font-bold">{{ text }}</span>
      </div>
    </app-base-button>
  `,
  styles: [`
    @keyframes subtle-pulse {
      0%, 100% { transform: scale(1); opacity: 1;}
      50% { transform: scale(1.06); opacity: 1;}
    }
    :host.attention-pulse {
      animation: subtle-pulse 1s ease-in-out infinite;
    }
  `],
  host: {
    '[class.attention-pulse]': 'attention',
    '[style.animation-delay.ms]': 'animationDelay'
  }
})
export class TipButtonComponent {
  @Input() text: string = 'Action';
  @Input() disabled: boolean = false;
  @Input() selected: boolean = false;
  @Input() attention: boolean = false;
  @Input() animationDelay: number = 0;
  @Output() onClick = new EventEmitter<MouseEvent>();
}
